import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { DomainsAndMailboxDashboard } from "@/components/domains-mailboxes/DomainsAndMailboxDashboard"

const DomainsEmailsManagement = () => {
  // Component for managing domains and mailboxes with tab navigation
  return (
    <NewAppLayout fullWidth>
      <DomainsAndMailboxDashboard />
    </NewAppLayout>
  )
}

export default DomainsEmailsManagement
